/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/media-has-caption */
import { Button } from "@culturehq/components";
import { t, Trans } from "app/utils";
import React, { useRef, useState, useEffect, ReactNode, useCallback } from "react";
import { useReactMediaRecorder } from "react-media-recorder";


interface CameraRecorderProps {
  audioConstraints: any;
  videoConstraints: any;
  customMediaStream: any;
  status: "recording" | "stopped" | "paused" | "idle";
  onFinishRecord: (blobUrl: string) => void;
  onClick: () => void;
}

const CameraRecorderEffects: React.FC<CameraRecorderProps> = ({
  customMediaStream, videoConstraints, audioConstraints, status, onFinishRecord, onClick
}) => {
  const videoRef = useRef<any>(null);
  const recorder = useReactMediaRecorder({
    video: videoConstraints,
    audio: audioConstraints,
    customMediaStream
  });

  useEffect(() => {
    if (videoRef.current && customMediaStream) {
      if (!videoRef.current.srcObject) {
        videoRef.current.srcObject = recorder.previewStream;
        if (recorder.status === "idle") {
          recorder.startRecording();
        }
      }
    }
  }, [customMediaStream, recorder]);

  useEffect(() => {
    if (recorder.mediaBlobUrl) onFinishRecord(recorder.mediaBlobUrl);
  }, [recorder.mediaBlobUrl]);

  useEffect(() => {
    switch (status) {
      case "stopped":
        recorder.stopRecording();
        break;
      case "paused":
        recorder.pauseRecording();
        break;
      case "recording":
        if (recorder.status === "paused") recorder.resumeRecording();
        break;
      default:
        break;
    }
  }, [status]);

  if (status === "stopped") {
    return (<></>);
  }

  return (
    <>
      <video onClick={onClick} className="Video-Preview__Source-Video" ref={videoRef} width={1080} autoPlay />
    </>
  );
};

export default CameraRecorderEffects;
